export type UnitSourceCategory = 'agent' | 'landlord' | 'bso' | 'unknown'
export type UnitSourceFilter = 'all' | Exclude<UnitSourceCategory, 'bso' | 'unknown'>

export const getUnitSourceCategory = (unit: any): UnitSourceCategory => {
    const statuses: string[] = Array.isArray(unit?.attributes?.Statuses) ? unit.attributes.Statuses : []
    if (statuses.includes('Landlord Unit') || statuses.includes('Approved')) return 'landlord'
    if (statuses.includes('Agent Unit')) return 'agent'

    const managedBy = String(unit?.attributes?.ManagedBy ?? '').trim().toLowerCase()
    if (managedBy === 'agent' || managedBy === 'landlord' || managedBy === 'bso') return managedBy
    return 'unknown'
}

export const getUnitSourceBadgeText = (unit: any): string => {
    const statuses: string[] = Array.isArray(unit?.attributes?.Statuses) ? unit.attributes.Statuses : []
    if (statuses.includes('Landlord Unit')) return 'Landlord Published'
    if (statuses.includes('Approved')) return 'Landlord Verified'
    if (statuses.includes('Agent Unit')) return 'Agent Published'
    return String(unit?.attributes?.ManagedBy ?? '')
}
